import { render, staticRenderFns } from "./DetailPD.vue?vue&type=template&id=52148eed&scoped=true&"
import script from "./DetailPD.vue?vue&type=script&lang=js&"
export * from "./DetailPD.vue?vue&type=script&lang=js&"
import style0 from "./DetailPD.vue?vue&type=style&index=0&id=52148eed&prod&lang=scss&"
import style1 from "./DetailPD.vue?vue&type=style&index=1&id=52148eed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52148eed",
  null
  
)

export default component.exports